export default "__VITE_ASSET__B0p$Ta8r__"